<div class="content" *ngIf="init && docID">
	<ejs-pdfviewer [id]="'pdfViewer_' + docID"
	               [serviceUrl]="service"
	               [documentPath]="docPath"
	               [locale]="'de'" style="height: 100%; display: block"
								 [dateTimeFormat]="getGlobal('DateTimeFormatShort')"

	               [toolbarSettings]="viewerConfig.toolbarItemsConfig"
	               [annotationSettings]="viewerConfig.AnnotationSettings"

	               hyperlinkOpenState="NewTab"
	               (hyperlinkClick)="hyperlinkClicked($event)"

	               (importSuccess)="viewerReady($event)"
	               (documentLoad)="documentLoaded($event)"
	               (documentLoadFailed)="reload()"

	               (downloadStart)="downloadStart($event)"
	               (textSelectionEnd)="textSelected($event)"

	               (annotationAdd)="annotationEventListener($event)"
	               (annotationSelect)="annotationEventListener($event)"
	               (annotationUnSelect)="annotationEventListener($event)"
	               (annotationRemove)="annotationEventListener($event)"
	               (annotationMove)="annotationEventListener($event)"
	               (annotationResize)="annotationEventListener($event)"
	               (annotationPropertiesChange)="annotationEventListener($event)"

	               (commentAdd)="commentEventListener($event)"
	               (commentEdit)="commentEventListener($event)"
	               (commentDelete)="commentEventListener($event)"
	               (commentSelect)="commentEventListener($event)"
	               (commentStatusChanged)="commentEventListener($event)"

	               [enableTextSelection]="viewerConfig.toolbar.enableTextSelection"
	               [enableAnnotation]="viewerConfig.toolbar.enableAnnotation"
	               [enableAnnotationToolbar]="viewerConfig.toolbar.enableAnnotationToolbar"

	               [enableCommentPanel]="false"
	               [enableFormFields]="false"
	               [enableFormDesignerToolbar]="false"
	               [enableFormDesigner]="false">
	</ejs-pdfviewer>
</div>
